<template>
  <div class="wareManageDetailPage">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, index) in bannerList" :key="index"
        ><van-image width="100%" fit="scale-down" :src="item"
      /></van-swipe-item>
    </van-swipe>

    <div class="main_content">
      <div class="good_description">
        <div class="item">
          <!-- <p>商品ID：{{ shopItem.id }}</p> -->
          <p>商品名称：{{ shopItem.commodityname }}</p>
        </div>
        <div class="item">
          <div class="block">
            <!-- <p>排序：{{ shopItem.sort }}</p> -->
            <p>所属企业：{{ shopItem.qyname }}</p>
            <!-- <p>是否上架：{{ shopItem.commoditystate }}</p>
            <p>销售状态：{{ shopItem.salestate }}</p> -->
          </div>
          <div class="block">
            <!-- <p>是否精品推荐：{{ shopItem.isintro }}</p>
            <p>是否置顶：{{ shopItem.istop == 1 ? "是" : "否" }}</p>
            <p>是否限购：{{ shopItem.islimit }}</p> -->
            <p>SKU采购编码：{{ shopItem.sku }}</p>
            <p>品牌标签：{{ shopItem.brandname }}</p>
          </div>
        </div>
        <div class="item">
          <div class="block">
            <p>ISBN编码：{{ shopItem.ISBN }}</p>
          </div>
          <div class="block">
            <p>
              所属分类：{{
                this.label_name(
                  shopItem.labelid,
                  shopItem.labelid2,
                  shopItem.labelid3
                )
              }}
            </p>
            <!-- <p>商品类型：{{ shopItem.comtype }}</p>
            <p>结算类型：{{ shopItem.paytype }}</p>
            <p>基础零售价：{{ shopItem.price }}</p>
            <p>普通用户积分兑换值：{{ shopItem.userscore1 }}</p>
            <p>商务合作用户积分兑换值：{{ shopItem.userscore2 }}</p> -->
          </div>
          <div class="block">
            <!-- <p>企业积分兑换值：{{ shopItem.userscore3 }}</p>
            <p>基础批发价：{{ shopItem.pfprice }}</p>
            <p class="flex-between">
              <span>单款混选起批数量：{{ shopItem.startnum1 }}</span
              ><span>件/起批</span>
            </p> -->

            <!-- <p class="flex-between">
              <span>批发商品组规格：{{ shopItem.groupnum }}</span
              ><span>件/每组</span>
            </p>
            <p>批发售价：{{ shopItem.groupprice }}</p>
            <p class="flex-between">
              <span>单样单选起批数量：{{ shopItem.startnum1 }}</span
              ><span>组</span>
            </p>
            <p class="flex-between">
              <span>混样多选起批数量：{{ shopItem.startnum2 }}</span
              ><span>组</span>
            </p> -->
          </div>
        </div>
      </div>
      <div class="good_total">
        <p>
          <span>当前库存总量：</span><span>{{ shopItem.kunum }}</span>
        </p>
      </div>
      <div class="good_detail">
        <div class="tit">库存明细：</div>
        <div class="list" v-if="dataList.length > 0">
          <div class="item" v-for="item in dataList" :key="item.id">
            <p>数量：{{ item.num }}件</p>
            <div class="whild_wrap flex-rowl">
              <p class="txt">位置：</p>
              <p>
                <span>{{ item.whid1str }}</span>
                <span v-if="item.whid2str">/{{ item.whid2str }}</span>
                <span v-if="item.whid3str">/{{ item.whid3str }}</span>
                <span v-if="item.whid4str">/{{ item.whid4str }}</span>
              </p>
            </div>
            <p>
              属性：<span>{{ item.attr ? item.attr : "无" }}</span>
            </p>
            <!-- <p>
              商品属性标签：<span>{{ item.ams_shop_commodity_attridstr ? item.ams_shop_commodity_attridstr : '无' }}</span>
            </p>
            <p>
              商品属性标签值：
              <span>{{ item.ams_shop_commodity_attr_valuestr ? item.ams_shop_commodity_attr_valuestr : '无' }}</span>
            </p> -->
            <!-- <p>商品批次：{{ item.makerno }}</p>
            <p>生产商：{{ item.makername_str }}</p> -->
          </div>
        </div>
        <van-empty description="暂无数据" v-else />
        <!-- <div class="noData" v-else>暂无数据</div> -->
      </div>
    </div>

    <div class="fixd_button_btm flex-rowl">
      <!-- <div class="return-fixd"> -->
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleShowRk">添加库存</div>
    </div>

    <!-- 弹窗 -->
    <van-popup
      v-model="isShowPopup"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="popup_wrap">
        <div class="close" @click="isShowPopup = false">
          <i class="iconfont icon-close"></i>
        </div>
        <div class="popup_wrap_info flex-colc">
          <div class="info-button" @click="handleGo('add')">入库操作</div>
          <div class="info-button" @click="handleGo('reduce')">出库操作</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import {
  getMenuAuthTwo,
  // queryShop,
  getCommondityLabel,
  getCommidityDetail,
  encryptstringadd,
  encryptstringview,
} from "../../api/api";
import { getShopInventoryRecordList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "wManageDetail",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      bannerList: "", // 商品banner
      shopLabelFirst: "", // 商品所属分类
      shopItem: "",

      cmid: "",
      keyword: "",
      realnum: 0,

      isShowPopup: false, // 是否显示弹窗

      params: {
        pageindex: 1,
        pagesize: 20,
        cmid: "",
      },
      loading: false, // 是否正在加载中
      dataList: [],
      listTotal: 0,
    };
  },
  computed: {
    // shopItem
    ...mapState(["OPENID"]),
  },
  created() {
    this.getMenuAuthTwo();

    let { routerList, menuItem, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.roleId = USERINFO.roleid;
    this.menuItem = menuItem;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { cmid, keyword } = JSON.parse(res.jsondata);
        this.keyword = keyword;
        this.cmid = cmid;
        this.params.cmid = cmid;
        this.getShopLabel();
        this.getShopDetail();
        this.getShopInventoryRecordList();
      } else {
        this.$router.back();
      }
    },

    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    // 获取商品详情
    getShopDetail() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getCommidityDetail({ id: this.cmid }).then((res) => {
        let bannerList = [];
        bannerList.push(res.banner);
        bannerList.push(res.banner2);
        bannerList.push(res.banner3);
        bannerList.push(res.banner4);
        bannerList.push(res.banner5);
        let filter = bannerList.filter((v) => v != "");
        this.bannerList = filter;
        this.shopItem = res;
        Toast.clear();
      });
    },
    // 获取商品库存明细表
    getShopInventoryRecordList() {
      this.loading = true;
      getShopInventoryRecordList(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
      });
    },
    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.getShopInventoryRecordList();
      }
    },

    // 获取商品分类标签
    getShopLabel() {
      getCommondityLabel().then((res) => {
        this.shopLabelFirst = res;
      });
    },
    // 商品所属分类
    label_name(id, id2, id3) {
      let { shopLabelFirst } = this;
      if (shopLabelFirst.length > 0 && id) {
        // 一级分类
        let filter = shopLabelFirst.filter((v) => v.id == id);
        if (filter.length > 0) {
          if (id2) {
            // 二级分类
            let filter2 = filter[0].childs2.filter((v) => v.id == id2);
            if (filter2.length > 0) {
              if (id3) {
                // 三级分类
                let filter3 = filter2[0].childs3.filter((v) => v.id == id3);
                return (
                  filter[0].labelname +
                  "、" +
                  filter2[0].labelname +
                  "、" +
                  filter3[0].labelname
                );
              }
              return filter[0].labelname + "、" + filter2[0].labelname;
            }
          }
          return filter[0].labelname;
        }
      }
    },

    handleShowRk() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      this.isShowPopup = true;
      // this.$router.push(`/warehousIndex/wManageSettingList/${this.keyword}`);
    },

    handleGo(type) {
      if (type == "reduce") {
        this.$toast("即将开放");
        return;
      }
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      // this.$router.push(
      //   `/warehousIndex/wManageSettingItem/${this.shopItem.id}/${type}`
      // );
      this.encryptstringadd("wManageSettingItem", {
        id: this.shopItem.id,
        type,
      });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.wareManageDetailPage {
  padding-bottom: 320px;
  .my-swipe {
    height: 750px;
    background: #f8f8f8;
  }
  .main_content {
    padding: 69px 69px 140px;
    .good_description {
      font-size: 22px;
      color: #404d6c;
      .item {
        margin-bottom: 50px;
        p {
          margin-bottom: 9px;
        }
        .block {
          margin-bottom: 35px;
        }
      }
    }
  }

  .good_total {
    font-size: 30px;
    margin-bottom: 50px;
  }
  .good_detail {
    font-size: 22px;
    .tit {
      font-size: 30px;
      margin-bottom: 30px;
    }
    .item {
      border-top: 1px solid #bebebe;
      padding: 25px 0;
      p {
        margin-bottom: 20px;
      }
      span {
        line-height: 25px;
        display: inline-block;
      }
      .whild_wrap {
        align-items: flex-start;
        .txt {
          white-space: nowrap;
        }
      }
    }
  }
}
/deep/ .van-popup {
  z-index: 1000002 !important;
  background-color: transparent !important;
}
.popup_wrap {
  height: 100%;
  background: #fff;
  position: relative;
  .close {
    position: absolute;
    top: 10px;
    right: 30px;
    .iconfont {
      font-size: 50px;
    }
  }
  .popup_wrap_info {
    height: 100%;
  }
  .info-button {
    &:nth-child(2) {
      margin: 30px auto;
    }
  }
}
</style>